import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '代理店詳細',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
